import { Box, BoxProps } from "@chakra-ui/react";
import { IconType } from "common";
import { AppIcon } from "./AppIcon";
import { toHexColor } from "./toHexColor";

interface TeamBannerProps extends Omit<BoxProps, "id"> {
  color: string;
  iconType: IconType;
  iconColor: string;
  width: number;
  padding?: number;
  iconSize?: number;
}

export const TeamBanner = ({
  padding,
  color,
  iconType,
  iconColor,
  width,
  iconSize,
  ...props
}: TeamBannerProps) => {
  return (
    <Box width={`${width}px`} {...props}>
      <AppIcon
        paddingTop={padding}
        paddingBottom={padding}
        backgroundColor={toHexColor(color)}
        type={iconType}
        color={iconColor}
        size={iconSize ?? 50}
      />
      <Box
        position={"relative"}
        top={-0.5}
        width={0}
        height={0}
        border={`${width / 2}px solid transparent`}
        borderBottom={0}
        borderTop={`20px solid ${toHexColor(color)}`}
      ></Box>
    </Box>
  );
};
